import './styles/ActionModal.css'
import { useState,useEffect } from 'react';
import Action from './Action'
import Modal from 'react-modal';
import Selector from './Selector'
import InputForm from './InputForm';
import LoadAdding from './LoadAdding';
import { useFetch } from '../hooks/useFetch'
const ActionModal = ({ mode, isOpen, ip, handleShowPopup, data, actionSelected, statusPing, closeActionModal, server }) => {
  const [dataPing, setDataPing] = useState({ data: [], loading: false, error: null })
  const [ejecuta, setEjecuta] = useState(false)

  const Ejecutar = () => {
    setEjecuta(true)
    let method = 'POST'
    setDataPing({ data: dataPing.data, loading: true, error: null })
    const fetchDataPost = async () => {
      try {
        const response = await fetch(server.url + '/api/v1/zabbix/hosts/action/' + ip + '/' + actionSelected.action_id, {
          method: method,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        });
        if (response.ok) {
          const data1 = await response.json();
          setDataPing({ data: data1, loading: false, error: null });
          
          // Mantener el popup de notificación del sistema
          if (handleShowPopup) {
            handleShowPopup(
              (data1.success ? 'Completado' : (data1.message || 'Error')),
              (data1.data?.action === "true" 
                ? `Acción "${actionSelected.name}" al dispositivo "${ip}" ejecutada correctamente` 
                : `Acción "${actionSelected.name}" al dispositivo "${ip}" ejecutada sin éxito`),
              (data1.recommendation || ''),
              data1.data?.action === "true"
            );
          }
        } else {
          setDataPing({ data: { data: { action: "false" } }, loading: false, error: 'Error en la solicitud' });
          if (handleShowPopup) {
            handleShowPopup('Error!!!', `La solicitud al servidor falló para "${actionSelected.name}"`, 'Consulte al administrador del sistema', false);
          }
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        setDataPing({ data: null, loading: false, error: error });
        if (handleShowPopup) {
          handleShowPopup('Error!!!', `Acción "${actionSelected.name}" al dispositivo "${ip}" ejecutada sin éxito`, 'Favor de reportar el error en consola', false);
        }
        console.error(error);
      }
    };
    fetchDataPost();
  }

  return (
    <div className="action-modal-container">
      <div className="action-modal-header">
        <h3>Ejecutar Acción</h3>
        <div className="action-modal-close" onClick={closeActionModal}>&times;</div>
      </div>

      <div className="action-modal-body">
        {!ejecuta ? (
          <div className="action-prompt">
            <div className="action-icon-circle">
              <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
              </svg>
            </div>
            <p style={{ margin: 0, fontSize: '15px', color: '#334155' }}>
              ¿Desea ejecutar la acción <strong style={{ color: '#1e40af' }}>"{actionSelected.name}"</strong>?
            </p>
            <span className="action-ip-badge">{ip}</span>
          </div>
        ) : (
          <div className="action-execution-status" style={{ width: '100%' }}>
            {dataPing.loading ? (
              <div className="action-loading-state">
                <div className="action-spinner"></div>
                <p style={{ margin: 0, fontWeight: 600, color: '#64748b' }}>Procesando comando en el host...</p>
              </div>
            ) : dataPing.data && dataPing.data.data ? (
              <div className="action-result-container">
                <div className={`action-result-banner ${dataPing.data.data.action === "true" ? 'success' : 'error'}`}>
                  {dataPing.data.data.action === "true" ? '✓ Ejecución Finalizada' : '✕ Error de Ejecución'}
                </div>

                {dataPing.data.data.action === "true" ? (
                  <div className="action-details-box">
                    <div className="action-detail-item">
                      <span className="label">Tiempo de respuesta</span>
                      <span className="value">{dataPing.data.data.total_time} ms</span>
                    </div>
                    <div className="action-detail-item terminal">
                      <span className="label">Salida del comando</span>
                      <pre className="value-terminal">{dataPing.data.data.result || 'Sin salida de datos'}</pre>
                    </div>
                  </div>
                ) : (
                  <div className="action-error-msg" style={{ textAlign: 'center', color: '#991b1b', fontSize: '13px' }}>
                    El host no respondió correctamente a la solicitud.
                  </div>
                )}
              </div>
            ) : (
              <div className="action-error-state" style={{ textAlign: 'center' }}>
                <p style={{ color: '#b91c1c', fontWeight: 600 }}>Ocurrió un error de red o de permisos.</p>
                <span style={{ fontSize: '12px', color: '#64748b' }}>Consulte los logs de la consola para más detalles.</span>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="action-modal-footer">
        {!ejecuta ? (
          <>
            <button className="btn-action-cancel" onClick={closeActionModal}>Cancelar</button>
            <button className="btn-action-confirm" onClick={Ejecutar}>Confirmar</button>
          </>
        ) : (
          <button className="btn-action-confirm" onClick={closeActionModal}>Cerrar Ventana</button>
        )}
      </div>
    </div>
  );
};

export default ActionModal